<template>
  <div v-if="!isMinimalLayout" class="relative" data-testid="breadcrumb">
    <div class="absolute left-0 w-12 h-full" />
    <div
      class="sm:container whitespace-nowrap bread-crumb flex items-center h-8 overflow-x-auto fluid-xs leading-tightest font-medium px-1 -translate-x-1"
    >
      <!-- Container renders breadcrumb items when available -->
      <div class="breadcrumb-items-container flex items-center">
        <div v-for="({ label, route }, index) in activeBreadcrumbs" :key="index" class="last:pr-8 sm:last:pr-0">
          <TriangleIcon class="spacer ml-2 h-1" v-if="index !== 0" />
          <nuxt-link :to="route" class="ml-1" data-testid="breadcrumb-child">
            {{ label }}
          </nuxt-link>
        </div>
      </div>
    </div>
    <div class="absolute top-0 right-0 w-12 h-full" />
  </div>
</template>

<script setup>
import { usePageStore } from '@/stores/page';
import TriangleIcon from '@/components/icons/TriangleIcon';

const pageStore = usePageStore();
const route = useRoute();

// Track client-side hydration state
const isHydrated = ref(false);

const isMinimalLayout = computed(() => route.meta.layout === 'minimal');

// Access breadCrumb from the Pinia store
const breadCrumb = computed(() => pageStore.breadCrumb);

// Safely check if we have breadcrumbs to display
const hasBreadcrumbs = computed(() => {
  return Array.isArray(breadCrumb.value) && breadCrumb.value.length > 0 && isHydrated.value;
});

// Active breadcrumbs for template rendering
const activeBreadcrumbs = computed(() => {
  return hasBreadcrumbs.value ? breadCrumb.value : [];
});

// Initialize store safely during SSR to avoid mismatches
onServerPrefetch(() => {
  // Ensure breadcrumbs are empty array during SSR if not set
  if (!Array.isArray(pageStore.breadCrumb)) {
    pageStore.setBreadCrumb([]);
  }
});

// After client-side hydration, we can safely show breadcrumbs
onMounted(() => {
  isHydrated.value = true;
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
svg {
  @apply inline-block fill-current stroke-current stroke-0;
}
.bread-crumb {
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
}
.bread-crumb::-webkit-scrollbar {
  @apply hidden;
}
.bread-crumb-fadeout-to-left {
  background: linear-gradient(to left, rgb(213, 224, 202) 30%, rgba(213, 224, 202, 0) 70%);
}
.bread-crumb-fadeout-to-right {
  background: linear-gradient(to right, rgb(213, 224, 202) 30%, rgba(213, 224, 202, 0) 70%);
}
</style>
